import { render, staticRenderFns } from "./purchases.vue?vue&type=template&id=ff9f82f0"
import script from "./purchases.vue?vue&type=script&lang=js"
export * from "./purchases.vue?vue&type=script&lang=js"
import style0 from "./purchases.vue?vue&type=style&index=0&id=ff9f82f0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports